import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ShopTaxSettings {
  id: string;
  shop_id: string;
  mode: 'manual' | 'suggested' | 'api';
  provider: 'none' | 'taxjar' | 'avalara';
  combined_rate: number;
  state_rate: number;
  local_rate: number;
  source_label: string | null;
  manual_override: boolean;
  last_lookup_at: string | null;
}

const DEFAULT: Omit<ShopTaxSettings, 'id' | 'shop_id'> = {
  mode: 'manual',
  provider: 'none',
  combined_rate: 0,
  state_rate: 0,
  local_rate: 0,
  source_label: null,
  manual_override: true,
  last_lookup_at: null,
};

export function useShopTaxSettings(shopId: string | null | undefined) {
  return useQuery({
    queryKey: ['shop_tax_settings', shopId],
    enabled: !!shopId,
    queryFn: async (): Promise<ShopTaxSettings> => {
      const { data, error } = await supabase
        .from('shop_tax_settings' as any)
        .select('*')
        .eq('shop_id', shopId!)
        .maybeSingle();
      if (error) throw error;
      if (!data) {
        return { id: '', shop_id: shopId!, ...DEFAULT };
      }
      return data as unknown as ShopTaxSettings;
    },
  });
}
